
import { faviconLinks } from "@utils";
import { PAGES, AD_LAYOUT_STUBS } from "@consts";

const isBlog404 = (path) => path.includes("/blog/");

/**
 * This "layout" is special, and it will be embededed within the <Nuxt /> component in the default layout.
 * This is the intended way nuxt works with error pages. (shrug). This is the reason why we don't need to add
 * the rest of the elements to the html above, such header, footer... and also that's the reason why we need
 * an !important override in the css to make the layout according to specification, as we don't need another
 * column for that. Thanks nuxt, I guess, for making things easier for developers.
 *
 * More info about error pages here -> https://nuxtjs.org/docs/concepts/views/#error-page.
 */
export default {
	layout(context) {
		switch (context.store.state?.error?.statusCode) {
			case 404:
			case 500:
				return "error_layout_404";
			default:
				return "error_layout_generic";
		}
	},
	props: {
		error: {
			required: true,
			type: Object,
		},
	},
	data() {
		return {
			AD_LAYOUT_STUBS,
		};
	},
	head() {
		return {
			meta: [
				{
					name: "robots",
					content: "noindex",
				},
			],
			link: faviconLinks({ isBlueBranding: this.$isBlueBranding }),
		};
	},
	computed: {
		is500Error() {
			const statusCode =
				this.$store.state.error?.statusCode || this.error?.statusCode;

			return statusCode === 500;
		},
		gameName() {
			switch (this.$route.name) {
				case PAGES.NYT_CONNECTIONS:
				case PAGES.NYT_CONNECTIONS_TODAY:
				case PAGES.NYT_CONNECTIONS_YESTERDAY:
					return "NYT Connections";
				case PAGES.NYT_STRANDS:
					return "NYT Strands";
				case PAGES.SPELLING_BEE_LANDING:
					return "NYT Spelling Bee";
				case PAGES.NYT_GAMES:
					return "NYT Games";
				case PAGES.WORDLE:
				case PAGES.WORDLE_RESULTS:
				case PAGES.WORDLE_ANSWERS:
				case PAGES.WORDLE_HINTS:
					return "Wordle";
				case PAGES.CONTEXTO:
					return "Contexto";
				default:
					return "Whoops!";
			}
		},
	},
	created() {
		this.alternativePageAriaLabelKey = isBlog404(this.$route.path)
			? "ErrorPageReadBlogButtonAriaLabel"
			: "ErrorPageSeeWordListsButtonAriaLabel";

		this.alternativePageButtonTextKey = isBlog404(this.$route.path)
			? "ErrorPageReadBlogButtonText"
			: "ErrorPageSeeWordListsButtonText";
	},
	methods: {
		goToHome() {
			this.$router.push(PAGES.HOME);
		},

		goToAlternativePage() {
			this.$router.push(
				isBlog404(this.$route.path)
					? PAGES.ARTICLE_INDEX
					: PAGES.WORDS_LISTS_INDEX
			);
		},
	},
};
